import { useMemo } from 'react'

import { RecommendationAutomationRegistry } from '$extensionSrc/automations/automationMachineInterfaces'
import { getRecommendationAutomationRegistryForPlatform } from '$extensionSrc/automations/recommendationAutomationRegistryApi'
import { PLATFORM } from '$extensionSrc/utils/enums'

export type RecommendationAutomationSpecs =
  Partial<RecommendationAutomationRegistry>

export function getRecommendationAutomationSpecs(
  platform: PLATFORM | null | undefined,
): RecommendationAutomationSpecs | undefined {
  if (platform === undefined) {
    return undefined
  }
  if (platform === null) {
    return {}
  }
  return getRecommendationAutomationRegistryForPlatform(platform)
}

export function useRecommendationAutomationSpecs(
  platform: PLATFORM | null | undefined,
): RecommendationAutomationSpecs | undefined {
  return useMemo(() => getRecommendationAutomationSpecs(platform), [platform])
}
